import { CSVLink } from 'react-csv'
import { Button } from 'reactstrap'
import dayjs from 'dayjs'
import { userRoles } from '../mock-data/roles'

const ExportVisit = ({ datasets, isDisabled = false, style }) => {
  const headers = [
    { label: 'Date', key: 'date' },
    { label: 'Visitor', key: 'visit_person' },
    { label: 'Co Visitor', key: 'co_visitor' },
    { label: 'Township', key: 'township' },
    { label: 'Type of Visit', key: 'visit_type' },
    { label: 'Place of Visit', key: 'place_of_visit' },
  ]

  const exportedData = datasets.map((v) => {
    return {
      ...v,
      date: dayjs(v.date).format('YYYY/MM/DD'),
      township: v?.townships.map((t) => t.short_code).join(),
      visit_person: v?.visitor.username,
      co_visitor: v?.co_visitors
        ?.map(
          (e) =>
            `${e.username} (${
              userRoles.find((role) => role.id === e.role)?.name
            }),`
        )
        .join(),
      visit_type: v?.type_of_visit == 1 ? 'In Person' : 'Virtual',
    }
  })

  return (
    <CSVLink filename={"supervision-visit"} data={exportedData} headers={headers}>
      <Button
        disabled={isDisabled}
        style={{ ...style }}
        color="warning"
        type="button"
      >
        Export
      </Button>
    </CSVLink>
   
  )
}
export default ExportVisit
